export const Responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4500, min: 4000 },
    items: 8.5,
  },
  superLarDesktop: {
    breakpoint: { max: 3500, min: 3000 },
    items: 7.5,
  },
  LargeDesktop: {
    breakpoint: { max: 3000, min: 2500 },
    items: 7,
  },

  desktopLaar: {
    breakpoint: {
      max: 2500,
      min: 2200,
    },
    items: 6.5,
    // slidesToSlide: 5,
    // partialVisibilityGutter: 40,
  },

  desktopLaa: {
    breakpoint: {
      max: 2200,
      min: 2000,
    },
    items: 6,
    // slidesToSlide: 5,
    // partialVisibilityGutter: 40,
  },
  desktopLa: {
    breakpoint: {
      max: 2000,
      min: 1600,
    },
    items: 5.5,
    // slidesToSlide: 5,
    // partialVisibilityGutter: 40,
  },
  desktopL: {
    breakpoint: {
      max: 1600,
      min: 1400,
    },
    items: 4.5,
    // slidesToSlide: 5,
    // partialVisibilityGutter: 40,
  },
  desktop: {
    breakpoint: {
      max: 1400,
      min: 1280,
    },
    items: 4,
    // slidesToSlide: 5,
    // partialVisibilityGutter: 40,
  },
  mobileP: {
    breakpoint: {
      max: 360,
      min: 0,
    },
    items: 1,
    partialVisibilityGutter: 120,
  },
  mobileM: {
    breakpoint: {
      max: 400,
      min: 361,
    },
    items: 1,
    partialVisibilityGutter: 137,
  },
  mobileG: {
    breakpoint: {
      max: 480,
      min: 401,
    },
    items: 1,
    partialVisibilityGutter: 175,
  },
  tabletP: {
    breakpoint: {
      max: 900,
      min: 480,
    },
    items: 2,
    partialVisibilityGutter: 0,
  },
  tabletM: {
    breakpoint: {
      max: 1020,
      min: 901,
    },
    items: 3,
    partialVisibilityGutter: 0,
  },
};
